import Cookies from "js-cookie";

/**
 * Determines if secure flag should be used for cookies
 * Returns true only if HTTPS is being used
 */
const isSecureEnvironment = () => {
  return window.location.protocol === "https:";
};

/**
 * Get cookie options based on environment
 * On localhost/HTTP, removes secure flag to prevent errors
 */
const getCookieOptions = () => {
  return {
    path: "/",
    sameSite: "strict",
    secure: isSecureEnvironment(), // Only use secure on HTTPS
  };
};

/**
 * Safely set a cookie with expiration
 */
export const setCookieWithExpiration = (name, value, days) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);

  try {
    Cookies.set(name, value, {
      expires: expirationDate,
      ...getCookieOptions(),
    });
  } catch (error) {
    console.warn(`Error setting cookie ${name}:`, error);
  }
};

/**
 * Safely get a cookie value
 */
export const getCookieValue = (name) => {
  try {
    return Cookies.get(name);
  } catch (error) {
    console.warn(`Error getting cookie ${name}:`, error);
    return undefined;
  }
};

/**
 * Safely remove a cookie
 */
export const removeCookie = (name) => {
  try {
    Cookies.remove(name, getCookieOptions());
  } catch (error) {
    console.warn(`Error removing cookie ${name}:`, error);
  }
};

/**
 * Check if user is logged in
 */
export const isUserLoggedIn = () => {
  const userId = getCookieValue("usersessionId");
  return Boolean(userId);
};
